<!--remover comment-->
<template>
  <div>
    <b-container>
      <div v-if='anulErroOficio == true' style="margin-top: 10px">
        <b-card bg-variant="danger" text-variant="white" header="Diploma Anulado" class="text-center">
          <b-card-text>{{this.msgAnulacao}}</b-card-text>
        </b-card>
      </div>
      <div v-if='anulErroFato == true' style="margin-top: 10px">
        <b-card bg-variant="danger" text-variant="white" header="Diploma Anulado" class="text-center">
          <b-card-text>
            {{this.msgAnulacao}}<br><br><b>Motivo:</b> "{{this.items.motivo_anulacao}}"
          </b-card-text>
        </b-card>
      </div>
      <div v-if="dDisable == true ">
        <h1>Dados do Diploma</h1>
        <b-card>
        <b-row class="line_dip">
          <b-col class="returnDados" lg="3">
            <label for="inputNome">Nome</label>
            <b-form-input id="inputNome" v-model="items.nome" disabled></b-form-input>
          </b-col>
          <b-col class="returnDados" lg="3">
            <label for="inputCPF">CPF</label>
            <b-form-input id="inputCPF" v-model="items.cpf" disabled></b-form-input>
          </b-col>
          <b-col class="returnDados" lg="6">
            <label for="inputCurso">Curso</label>
            <b-form-input id="inputCurso" v-model="items.curso" disabled></b-form-input>
          </b-col>
        </b-row>
        <b-row class="line_dip">
          <b-col class="returnDados" lg="3">
            <label for="inputDtIngresso">Data de Ingresso</label>
            <b-form-input type="date" id="inputDtIngresso" v-model="items.dt_ingresso" disabled></b-form-input>
          </b-col>
          <b-col class="returnDados" lg="3">
            <label for="inputDtPub">Data Public. Diploma</label>
            <b-form-input type="date" id="inputDtPub" v-model="items.dt_public_dip" disabled></b-form-input>
          </b-col>
          <b-col class='returnDados' lg='3'>
              <label for='inputDtPub'>Data Conclusão</label>
              <b-form-input type='date' id='inputDtPub' v-model='items.dt_conclusao' disabled></b-form-input>
          </b-col>
          <b-col class="returnDados" lg="6">
            <label for="inputSitDip">Situação Diploma</label>
            <b-form-input id="inputSitDip" v-model="items.sit_diploma" disabled></b-form-input>
          </b-col>
        </b-row>
        <b-row class="line_dip">
          <b-col class="returnDados" lg="6">
            <label for="inputNomeExp">Nome da Expedidora</label>
            <b-form-input id="inputNomeExp" v-model="items.nome_expedidora" disabled></b-form-input>
          </b-col>
          <b-col class="returnDados" lg="3">
            <label for="inputDtExp">Data de Expedição</label>
            <b-form-input type="date" id="inputDtExp" v-model="items.dt_expedicao" disabled></b-form-input>
          </b-col>
          <b-col class="returnDados" lg="3">
            <label for="inputNumExp">Número expedição</label>
            <b-form-input id="inputNumExp" v-model="items.num_expedicao" disabled></b-form-input>
          </b-col>
        </b-row>
        <b-row class="line_dip">
          <b-col class="returnDados" lg="6">
            <label for="inputNomeReg">Nome da Registradora</label>
            <b-form-input id="inputNomeReg" v-model="items.nome_registradora" disabled></b-form-input>
          </b-col>
          <b-col class="returnDados" lg="3">
            <label for="inputNumReg">Número de Registro</label>
            <b-form-input id="inputNumReg" v-model="items.num_registro" disabled></b-form-input>
          </b-col>
          <b-col class="returnDados" lg="3">
            <label for="inputDtReg">Data de Registro</label>
            <b-form-input type="date" id="inputDtReg" v-model="items.dt_registro" disabled></b-form-input>
          </b-col>
        </b-row>
        <b-row>
          <b-button v-if="downloadsEnabled == true" v-on:click='download()' variant='outline-primary' style='margin-left: 15px'>
            <b-icon icon='download'></b-icon>  Download do XML
          </b-button>
        </b-row>
        <div v-if='anulErroFatoAtivo == true' style="margin-top: 10px">
          <div class="accordion" role="tablist">
            <b-button block v-b-toggle.clps-err-anul variant="danger">Aviso</b-button>
            <b-collapse id='clps-err-anul' role="tabpanel">
              <b-card bg-variant="danger" text-variant="white" class="text-center">
                <b-card-text>
                  {{this.msgAnulacao}}<br><br><b>Motivo:</b> "{{this.items.motivo_anulacao}}"
                </b-card-text>
              </b-card>
            </b-collapse>
          </div>
        </div>
        </b-card>
      </div>
        <div v-if="dDisable == false ">
            <h1>{{this.message}}</h1>
      </div>
    </b-container>
  </div>
</template>
<script>

import axios from 'axios'

// Util de formatação de data
function formatShortDate (dateStr) {
  let d = new Date(dateStr + 'T00:00:00')
  let day = d.getDate()
  let month = d.getMonth() + 1
  let year = d.getFullYear()

  if (day < 10) day = '0' + day
  if (month < 10) month = '0' + month

  return (day + '/' + month + '/' + year)
}

export default {
  name: 'DadosLinkUnico',
  data () {
    return {
      downloadsEnabled: false,
      message: '',
      anulErroFato: false,
      anulErroFatoAtivo: false,
      anulErroOficio: false,
      msgAnulacao: '',
      dDisable: '',
      fullPage: false,
      items: {
        id_curso_aluno: '',
        nome: '',
        cpf: '',
        curso: '',
        dt_ingresso: '',
        dt_conclusao: '',
        dt_public_dip: '',
        sit_diploma: '',
        nome_expedidora: '',
        dt_expedicao: '',
        num_expedicao: '',
        nome_registradora: '',
        num_registro: '',
        dt_registro: '',
        hr_erro_fato: '',
        dt_erro_fato: '',
        dt_erro_oficio: '',
        hr_erro_oficio: '',
        dt_ativacao: '',
        xml_publico: '',
        motivo_anulacao: ''
      },
      logoUrl: '',
      instituicao: null
    }
  },
  props: {
    nome: String
  },
  created () {
    this.buscaDados()
  },
  mounted () {
    this.instituicao = null
    axios.post(process.env.ROOT_API.concat('instituicao'), {})
      .then(response => {
        this.instituicao = response.data[0]

        // var aElement = document.createElement('a')

        // aElement.setAttribute('href', 'data:image/bmp;base64,' + btoa(this.instituicao.LOGOMARCA))
        // aElement.setAttribute('download', `teste.bmp`)

        // this.logoUrl = 'data:image/bmp;base64,' + btoa(this.instituicao.LOGOMARCA)
      }).catch(error => {
        console.log(error)
        this.makeToast('danger', 'Problemas ao conectar com o servidor.', 'Atenção')
      })
  },
  methods: {
    buscaDados: function () {
      let loader = this.$loading.show({
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: false,
        color: '#17A2B8'
      })

      // REMOVER QUANDO ESTIER NA EMPRESA
      var vm = this
      axios.get(process.env.ROOT_API.concat(`diploma/${this.$route.params.codigo}`))
        .then(response => {
          if (response.status === 200 && !response.data.msg) {
            vm.dDisable = true
            vm.anulErroOficio = false
            vm.anulErroFato = false
            vm.anulErroFatoAtivo = false
            vm.enableNameTbl = false
            vm.items.id_curso_aluno = response.data[0].ID_CURSO_ALUNO
            vm.items.nome = response.data[0].NOME_PESSOA
            vm.items.cpf = response.data[0].CPF
            vm.items.curso = response.data[0].EMEC_CURSO
            vm.items.dt_ingresso = response.data[0].DT_INGRESSO
            vm.items.dt_conclusao = response.data[0].DT_CONCLUSAO
            vm.items.dt_public_dip = response.data[0].DT_EXP_DIPLOMA
            vm.items.sit_diploma = response.data[0].SITUACAO
            vm.items.nome_expedidora = response.data[0].EMEC_EXPEDIDORA
            vm.items.dt_expedicao = response.data[0].DT_EXP_DIPLOMA
            vm.items.num_expedicao = response.data[0].NUM_EXPEDICAO
            vm.items.nome_registradora = response.data[0].EMEC_REGISTRADORA
            vm.items.dt_registro = response.data[0].DT_REGISTRO
            vm.items.num_registro = response.data[0].NUM_REGISTRO
            vm.items.xml_publico = response.data[0].XML_PUBLICO

            if (response.data[0].SITUACAO_ITEM === 14) {
              vm.items.dt_erro_fato = formatShortDate(response.data[0].DT_ERRO_FATO)
              vm.items.hr_erro_fato = response.data[0].HR_ERRO_FATO
              vm.items.motivo_anulacao = response.data[0].MOTIVO

              vm.msgAnulacao = `O diploma de "${vm.items.nome}" foi anulado por erro de fato em ${vm.items.dt_erro_fato} às ${vm.items.hr_erro_fato}.`

              vm.anulErroFato = true
              vm.dDisable = false
            } else if (response.data[0].SITUACAO_ITEM >= 10 && response.data[0].SITUACAO_ITEM < 14) {
              vm.items.dt_erro_oficio = formatShortDate(response.data[0].DT_ERRO_OFICIO)
              vm.items.hr_erro_oficio = response.data[0].HR_ERRO_OFICIO

              vm.msgAnulacao = `O diploma de "${vm.items.nome}" está na situação "${vm.items.sit_diploma}" desde ${vm.items.dt_erro_oficio} às ${vm.items.hr_erro_oficio}.`

              vm.anulErroOficio = true
              vm.dDisable = false
            } else {
              if (response.data[0].DT_ATIVACAO != null && response.data[0].DT_ERRO_FATO != null) {
                vm.items.motivo_anulacao = response.data[0].MOTIVO
                let dtErroFato = formatShortDate(response.data[0].DT_ERRO_FATO)
                let dtAtivacao = formatShortDate(response.data[0].DT_ATIVACAO)
                vm.msgAnulacao = `Este diploma já esteve anulado por erro de fato no período entre ${dtErroFato} e ${dtAtivacao}.`
                vm.anulErroFatoAtivo = true
              }
            }

            if (response.data[0].SITUACAO_ITEM === 3) {
              vm.items.sit_diploma = 'Ativo'
            } else {
              vm.items.sit_diploma = 'Anulado'
            }
            // if (vm.items.xml_publico === null) {
            //   vm.downloadsEnabled = false
            // } else {
            //   vm.downloadsEnabled = true
            // }
            // PERSONALIZADO POR CLIENTE
            if (this.instituicao) {
              let sigla = this.instituicao.COD_INSTITUICAO.trim()
              switch (sigla) {
                case 'UFT': // UFT JÁ DISSE QUE NÃO QUER O DOWNLOAD
                  vm.downloadsEnabled = false
                  break
                default:
                  vm.downloadsEnabled = false
                  break
              }
            }
            loader.hide()
          } else {
            loader.hide()
            vm.dDisable = false
            vm.message = 'Diploma não encontrado.'
          }
        }).catch(() => {
          loader.hide()
          vm.dDisable = false
          vm.makeToast('danger', 'Problemas ao conectar com o servidor.', 'Atenção')
        })
    },
    makeToast (variant = null, MSG, Title) {
      this.$bvToast.toast(MSG, {
        title: Title,
        variant: variant,
        solid: true
      })
    },
    download () {
      if (this.items.xml_publico != null) {
        var aElemento = document.createElement('a')

        aElemento.setAttribute('href', 'data:text/xml;charset=utf-8,' + encodeURIComponent(this.items.xml_publico))
        aElemento.setAttribute('download', 'xml ' + this.items.id_curso_aluno)

        if (document.createEvent) {
          var event = document.createEvent('MouseEvents')
          event.initEvent('click', true, true)
          aElemento.dispatchEvent(event)
        } else {
          aElemento.click()
        }
      }
    }
  },
  components: {
    axios
  }
}
</script>
<style scoped>
  .line_dip {
    margin-bottom: 10px;
  }
  .returnDados {
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// src/pages/DadosLinkUnico.vue